import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Box.css';

const Bar = props => (
  <div className={classNames('box', props.className)}>
    {props.children}
  </div>
);

Bar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Bar;



// WEBPACK FOOTER //
// ./src/components/Box/Box.jsx